module.exports = __webpack_public_path__ + "static/media/sort-arrow.8774435a.svg";